import { useAuthenticatedBlobUrl } from '../../hooks/useAuthenticatedBlobUrl';

export function AuthenticatedImage(props: Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & { src: string }) {
  const { src, alt = '', ...rest } = props;
  const { blobUrl } = useAuthenticatedBlobUrl(src);
  return blobUrl ? <img {...rest} src={blobUrl} alt={alt} /> : null;
}
